import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import CSSModules from 'react-css-modules';
import Menu from 'material-ui/Menu';
import browserHistory from 'react-router/lib/browserHistory';

import Card from '../../Card';
import TeamsMenu from './TeamsMenu';
import { IDS } from '../../../constants/ids';
import styles from '../index.styl';

const UserLink = ({
  href,
  avatar,
  displayableName,
  teamsMenuItems,
  isTeamMember,
  isMobile,
}) => {
  const btnRef = useRef();
  const [menuShown, setMenuShown] = useState(false);

  const handleBtnEnter = () => {
    setMenuShown(true);
  };

  const handleBtnLeave = e => {
    if (menuShown && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();

      const leaveTop = e.nativeEvent.pageY < 0;
      const leaveLeft = e.nativeEvent.pageX < rect.x;
      const leaveRight = e.nativeEvent.pageX > rect.x + rect.width;

      if (leaveTop || leaveLeft || leaveRight) {
        handleCloseMenu();
      }
    }
  };

  const handleCloseMenu = () => {
    setMenuShown(false);
  };

  const handleOpenProfile = () => {
    if (!href) return;
    browserHistory.push(href);
    handleCloseMenu();
  };

  const linkCard = (
    <Card
      additionalContent={{ left: avatar }}
      text={{ primary: displayableName }}
    />
  );

  return (
    <If condition={isTeamMember && !isMobile}>
      {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
      <div
        ref={btnRef}
        onMouseEnter={handleBtnEnter}
        onMouseLeave={handleBtnLeave}
        onClick={handleOpenProfile}
        styleName="link"
        className="flex-grow-0"
      >
        {linkCard}
      </div>
      <Menu
        anchorEl={btnRef.current}
        open={menuShown}
        onClose={handleCloseMenu}
        style={{ top: 45, left: 0, zIndex: 0 }}
      >
        <TeamsMenu list={teamsMenuItems} handleClose={handleCloseMenu} />
      </Menu>
      <Else />
      <Link
        activeClassName={styles['link--active']}
        styleName="link"
        id={IDS.NAV_BAR.PROFILE}
        to={href}
        className="header-profile-link flex-grow-0"
      >
        {linkCard}
      </Link>
    </If>
  );
};

UserLink.propTypes = {
  href: PropTypes.string,
  avatar: PropTypes.any,
  displayableName: PropTypes.string,
  teamsMenuItems: PropTypes.array,
  isTeamMember: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default CSSModules(UserLink, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Header/Components/UserLink.jsx